import { Grid, MenuItem, Switch, TextField, Typography } from '@material-ui/core'
import React, { useState, useContext } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { UserProfileContextStore } from '../../../../context/UserProfileContext'
import { PolicyModificationContextStore } from '../../../../context/PolicyModificationContext'
import { SessionContextStore } from '../../../../context/SessionContext'
import FlexView from 'react-flexview/lib'
import { insuranceHistoryInTheLast31dayes, INSURER_OPTIONS } from '../../../../Constants'

export const OwnerHistorySection = () => {
  const methods = useFormContext()
  const modifyContext = useContext(PolicyModificationContextStore)
  const sessionContext = useContext(SessionContextStore)
  const insuranceHistoryQuestion = insuranceHistoryInTheLast31dayes.includes(sessionContext.user.state)
    ? 'Have you had motorcycle insurance in the past 31 days?'
    : 'Have you had motorcycle insurance in the past 6 months?'

  return (
    <React.Fragment>
      {!modifyContext.isRenewal && (
        <>
          <Typography className="gray bold">{'Insurance History'}</Typography>
          <FlexView vAlignContent={'center'}>
            <Typography className="gray">{insuranceHistoryQuestion}</Typography>
            <Controller name="insurance_in_past_year" control={methods.control} as={<Switch color="primary" />} />
          </FlexView>
          {methods.watch('insurance_in_past_year') == true && (
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Controller
                  control={methods.control}
                  rules={{ validate: x => x && x != 'default', required: true }}
                  name="current_insurer"
                  defaultValue={modifyContext.owner_details.currentInsurer || 'default'}
                  as={
                    <TextField
                      InputLabelProps={{ className: 'avenir-book' }}
                      select
                      helperText={'Please indicate your current insurer'}
                      error={!!methods.errors.current_insurer}
                      label={'Current Insurer'}
                      variant="outlined"
                      fullWidth
                      className="margin-bottom-basic margin-top-small"
                    >
                      {INSURER_OPTIONS.map(t => (
                        <MenuItem key={t} value={t}>
                          {t}
                        </MenuItem>
                      ))}
                    </TextField>
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                {methods.watch('current_insurer') === 'Other' && (
                  <>
                    <TextField
                      className="margin-bottom-basic margin-top-small"
                      variant="outlined"
                      label="Other"
                      autoComplete="other"
                      name="other"
                      inputRef={methods.register({ required: true })}
                      error={!!methods.errors.other}
                      helperText={!!methods.errors.other && methods.required}
                    />
                  </>
                )}
              </Grid>
            </Grid>
          )}
        </>
      )}
    </React.Fragment>
  )
}
